import { useMediaQuery } from "@/hooks/use-media-query";

const MOBILE_QUERY = "(max-width: 767px)";

/**
 * True on phones and narrow portrait devices. Useful for suppressing UI that is
 * too large or unsuitable for a small viewport (e.g. toast notifications).
 */
export function useIsMobile(): boolean {
  return useMediaQuery(MOBILE_QUERY);
}
